import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@services/config.service';
import { SearchService } from '@services/search.service';
import { SearchPayload } from '@shared/models/search.model';
import { ContentService } from '@services/content/content.service';

@Component({
  selector: 'app-news-display',
  templateUrl: './news-display.component.html',
  styleUrls: ['./news-display.component.scss'],
  standalone: false,
})
export class NewsDisplayComponent implements OnInit {
  news = '';
  newsStyle: { backgroundColor?: string; color?: string; fontSize?: string } = {};
  show = true;

  constructor(
    private searchService: SearchService,
    private configService: ConfigService,
    private contentService: ContentService,
  ) {}

  ngOnInit(): void {
    this.loadNews();
  }

  loadNews(): void {
    const currentLanguage = this.configService.getCurrentLanguage();
    const today = new Date().toISOString();
    const searchParams: SearchPayload = {
      fieldList: ['id'],
      fieldFilters: [
        {
          field: 'domain.key',
          values: ['DCP_DCP'],
        },
        {
          field: 'supertype.key',
          values: ['NEWS'],
        },
        {
          field: 'market.key',
          values: [currentLanguage === 'fr' ? 'GS_FR' : 'GS_INT'],
        },
        {
          field: 'lang.key',
          values: [currentLanguage === 'fr' ? 'fr' : 'en'],
        },
        {
          field: 'publicationStartDate',
          match: 'lessThan',
          values: [today],
        },
        {
          field: 'publicationEndDate',
          match: 'moreThan',
          values: [today],
        },
        {
          field: 'type.key',
          type: 'exclusion',
          values: ['RELEASE'],
        },
      ],
      facetFilters: [
        {
          facet: 'status',
          key: '51 27 3D 37 2D 2F 01 81 8D 01 9F C0 01 8F 0A 00¤¤VALIDATED¤¤Validé',
          value: '',
          type: 'inclusion',
        },
      ],
    };

    this.searchService.searchContents(searchParams, '', 10, 0, '', 'fr', 'GS_FR').subscribe((newsSearch) => {
      if (newsSearch?.content && newsSearch.content[0]) {
        this.contentService.getContent(newsSearch.content[0].identifier).subscribe((news) => {
          this.news = news.body;
          this.newsStyle = {};

          // Read html comment config inside the content
          // <!--BACKGROUND:(#[A-F0-9]{3,6}|[a-z]*)-->
          const regexBackground = this.news.match('<!--BACKGROUND:(#[A-Fa-z0-9]{3,6}|[a-z]*)-->');
          this.newsStyle.backgroundColor = regexBackground && regexBackground[1] ? regexBackground[1] : '#ed5565';

          // <!--COLOR:(#[A-F0-9]{3,6}|[a-z]*)-->
          const regexColor = this.news.match('<!--COLOR:(#[A-F0-9]{3,6}|[a-z]*)-->');
          this.newsStyle.color = regexColor && regexColor[1] ? regexColor[1] : 'white';

          // <!--FONT-SIZE:([0-9]+)px-->
          const regexFontSize = this.news.match('<!--FONT-SIZE:([0-9]+px)-->');
          this.newsStyle.fontSize = regexFontSize && regexFontSize[1] ? regexFontSize[1] : '14px';
        });
      }
    });
  }
}
